import { useRouter } from "next/router";

export type UrlQuery = Record<string, string | number | boolean | undefined>;

function _buildQueryWithAccessToken(query: UrlQuery) {
  const p = new URLSearchParams({});
  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (value) {
      p.set(key, value.toString());
    }
  });
  return p.toString();
}

function _parsePathParameters(name: string, query: UrlQuery) {
  const returnQuery = { ...query };
  const segments = name.split("/");
  const path = segments
    .map((segment) => {
      const offset = segment.indexOf(":") + 1;
      if (!offset) return segment;

      const key = segment.slice(offset);
      const value = returnQuery[key];
      if (value === undefined) {
        throw new Error("Missing PathParam " + key);
      }
      delete returnQuery[key];
      return encodeURIComponent(value.toString());
    })
    .join("/");
  return { path, query: returnQuery };
}

function _apiPath(rawPath: string, params: UrlQuery = {}) {
  const { path, query } = _parsePathParameters(rawPath, params);
  const queryString = _buildQueryWithAccessToken(query);
  if (queryString) {
    return path + "?" + queryString;
  } else {
    return path;
  }
}

export function useBackendUrl(path: string, params: UrlQuery = {}) {
  const { basePath } = useRouter();

  return basePath + "/api" + _apiPath(path, params);
}
